import styled from 'styled-components'

export const Brand = styled.img`
  height: 44px;
  width: 44px;
  margin: 2px 10px 2px 0;
  object-fit: contain;
`

export const HeaderItems = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`

export const BrandContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`

export const BrandLabel = styled.span`
  color: ${({ theme }) => theme.colors.headerText};
  font-size: 20px;
  font-weight: bold;
`

export const RouteName = styled.span`
  font-size: 20px;
  padding: 10px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.headerText};
`

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-end;
  padding: 5px;
`
